import React from 'react';

const Hero = () => {
  return (
    <section className="relative w-full h-screen overflow-hidden">
      {/* Hero Image with Grayscale Filter */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1542051841857-5f90071e7989?w=1920&q=80)',
          filter: 'grayscale(100%)'
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      </div>

      {/* Hero Text - Centered */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center px-8">
          <h1 className="text-white text-7xl md:text-8xl font-bold tracking-tight">
            <span className="font-serif italic">going plus</span>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default Hero;